import { DivCat, ListResponse, Location, LocationFilterItem } from '../../types';
import Axios from 'axios';
import { hopplerApi } from '../../constants';

class LocationService {
  SEARCH_URL = `${hopplerApi.host}/kumita/location/search`;
  LOCATION_URL = `${hopplerApi.host}/kumita/location/linear/search`;

  searchWithinLevel(level: 'city' | 'area', searchString: string, divCat: DivCat) {
    const basePath = `${hopplerApi.host}/api/locations/request/search/${level}`;
    const params = {
      location: searchString,
      pageSize: 10
    };

    return Axios.get<ListResponse<Location>>(basePath, {
      params,
      withCredentials: true
    });
  }

  search(searchString: string, divCat: DivCat, maxCount: number = 10) {
    const params = {
      search: searchString,
      category: divCat.category,
      type: divCat.type,
      pageSize: maxCount
    }

    return Axios.get<ListResponse<Location>>(this.SEARCH_URL, {
      params,
      withCredentials: true
    });
  }

  /**
   * Runs a location search using the linear search API.
   * 
   * This uses the same endpoint as `filterLocation` but with additional parameters.
   * `filterLocation` is retained to prevent unexpected incompatibility issues
   * in other parts of the site.
   * 
   * @param searchString 
   * @param divCat 
   * @param maxCount 
   */
  linearSearch(searchString: string, divCat?: DivCat, maxCount: number = 10) {
    const params = {
      search: searchString,
      category: divCat.category,
      type: divCat.type,
      pageSize: maxCount
    };

    return Axios.get<ListResponse<Location>>(this.LOCATION_URL, {
      params,
      withCredentials: true
    });
  }

  filterLocation(search: string) {
    const params = {
      search,
      page: 1,
      pageSize: 10
    }

    return Axios.get<ListResponse<LocationFilterItem>>(this.LOCATION_URL, {
      params,
      withCredentials: true
    })
  }
  

}

export const locationService = new LocationService();
